import { render, staticRenderFns } from "./OpenProfileModal.vue?vue&type=template&id=78fc360c&scoped=true&"
import script from "./OpenProfileModal.vue?vue&type=script&lang=js&"
export * from "./OpenProfileModal.vue?vue&type=script&lang=js&"
import style0 from "./OpenProfileModal.vue?vue&type=style&index=0&id=78fc360c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fc360c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VDialog,VIcon,VOverlay})
